import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/feature-list.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/feature-list.css');

export const FeatureListDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      You know those marketing pages that display feature images and
      descriptions in alternating order? There&rsquo;s one simple flexbox
      property that makes this easy to do:
    </p>

    <ul>
      <li>
        <code>flex-direction: row-reverse</code> displays the container&rsquo;s
        children in the reverse order of how they appear in the markup.
      </li>
    </ul>
  </DemoPage>
);

FeatureListDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/FeatureListDemo.js